import { render, staticRenderFns } from "./blogItem.vue?vue&type=template&id=7fdc0902&scoped=true&"
import script from "./blogItem.vue?vue&type=script&lang=js&"
export * from "./blogItem.vue?vue&type=script&lang=js&"
import style0 from "./blogItem.vue?vue&type=style&index=0&id=7fdc0902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdc0902",
  null
  
)

export default component.exports